document.addEventListener("DOMContentLoaded", function() {
    var videos = document.querySelectorAll(".scd-video-container .scd-video-control");
    videos.forEach(item => {
        item.addEventListener("click", function() {
            console.log("video-mode", this.getAttribute("video-mode"));
            var video_mode = this.getAttribute("video-mode");
            if(video_mode == "play") {
                this.closest(".scd-video-container").querySelector("video").play();
                this.setAttribute("video-mode", "stop");
            } else {
                this.closest(".scd-video-container").querySelector("video").pause();
                this.setAttribute("video-mode", "play");
            }
        });
    })
});